// extracted by mini-css-extract-plugin
module.exports = {"commentButton":"Button_commentButton__2NQuT"};